import { GLOBAL_ACTION_TYPE, GlobalAction } from "./GlobalAction";

export interface GlobalState {
  isLoading: boolean;
  isOpenSpMenu: boolean;
}

const initialState: GlobalState = {
  isLoading: false,
  isOpenSpMenu: false,
};

const globalReducer = (state: GlobalState = initialState, action: GlobalAction): GlobalState => {
  switch (action.type) {
    default:
      return state;
    case GLOBAL_ACTION_TYPE.START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GLOBAL_ACTION_TYPE.END_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case GLOBAL_ACTION_TYPE.TOGGLE_SP_MENU:
      return {
        ...state,
        isOpenSpMenu: !state.isOpenSpMenu,
      };
  }
};

export default globalReducer;
